import { getCustomerFullName } from "./customerCore";

export function getAddressFirstName(address) {
    return address?.firstName;
}

export function getAddressLastName(address) {
    return address?.lastName;
}

export function getAddressFullName(address) {
    return getCustomerFullName(address);
}

export function getAddressAttentionName(address) {
    return address?.attentionName;
}

export function getAddressEmail(address) {
    return address?.email;
}

export function getAddressPhone(address) {
    return address?.phone;
}
export function getAddressStreet(address) {
    return address?.street;
}
export function getAddressStreet2(address) {
    return address?.street2;
}
export function getAddressCity(address) {
    return address?.city;
}
export function getAddressCountryCode(address) {
    return address?.countryCode;
}
export function getAddressProvinceCode(address) {
    return address?.provinceCode;
}
export function getAddressZipCode(address) {
    return address?.zip;
}
